export default {"src":"/_next/static/media/option3.fe344344.svg","height":561,"width":664,"blurWidth":0,"blurHeight":0};